module.exports = __webpack_public_path__ + "static/media/promo-am.571322a8.png";